import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../services/api";
import { useAuth } from "./AuthContext";

const ProCartContext = createContext();
export const useProCart = () => useContext(ProCartContext);

const CH = { params: { channel: "pro" } };

export const ProCartProvider = ({ children }) => {
  const { user, authReady } = useAuth();
  const isPro = !!(user && user.is_pro);
  const [items, setItems] = useState([]);

  const refresh = useCallback(async () => {
    if (!isPro) { setItems([]); return; }
    try { const { data } = await api.get("/cart", CH); setItems(data.items); } catch { setItems([]); }
  }, [isPro]);

  useEffect(() => { if (authReady) refresh(); }, [authReady, refresh]);

  const addItem = async (product, qty = 1) => {
    if (!isPro) return;
    const { data } = await api.post("/cart", { product_id: product.id, qty }, CH);
    setItems(data.items);
  };

  const removeItem = async (id) => {
    const { data } = await api.delete(`/cart/${id}`, CH);
    setItems(data.items);
  };

  const updateQty = async (id, qty) => {
    if (qty < 1) return removeItem(id);
    const { data } = await api.put(`/cart/${id}`, { qty }, CH);
    setItems(data.items);
  };

  const clearCart = async () => { await api.delete("/cart", CH); setItems([]); };

  const createOrder = async (promoCode = null) => {
    const { data } = await api.post("/orders", { promo_code: promoCode, channel: "pro" });
    setItems([]);
    return data;
  };

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <ProCartContext.Provider value={{ items, addItem, removeItem, updateQty, clearCart, createOrder, count, total, refresh }}>
      {children}
    </ProCartContext.Provider>
  );
};
